import { noop } from '@direct-frontend/stdlib';
import type { DrawerProps } from './lib/types';
import { useIsDesktop } from '../../lib/hooks';
import { Dialog, DialogContent } from '../Dialog';
import { DrawerBody } from './DrawerBody';
import { DrawerProvider } from './DrawerContext';
import styles from './Drawer.module.css';

export const Drawer = ({
    'data-testid': dataTestId = 'Drawer',
    isFullscreen,
    isScrollable,
    isOpen,
    isSnapChildren,
    snapPoints = [0.75, 1],
    onClose,
    children,
    header,
    dismissOnOutsideClick = true,
    closable = true,
    size = 'xs',
    onAnimationEnd,
    ...props
}: DrawerProps) => {
    const { isDesktop } = useIsDesktop();

    return (
        <DrawerProvider
            isFullscreen={isFullscreen}
            isScrollable={isScrollable}
            isOpen={isOpen}
            isSnapChildren={isSnapChildren}
            snapPoints={snapPoints}
            onClose={onClose}
        >
            {isDesktop ? (
                <Dialog
                    size={size}
                    className={styles.newDialog}
                    isOpen={Boolean(isOpen)}
                    onClose={onClose ? onClose : noop}
                    closable={closable}
                    dismissOnOutsideClick={dismissOnOutsideClick}
                    onAnimationEnd={onAnimationEnd}
                    data-testid={dataTestId}
                >
                    {header}

                    <DialogContent className={styles.dialogContent}>{children}</DialogContent>
                </Dialog>
            ) : (
                <DrawerBody
                    data-testid={dataTestId}
                    children={children}
                    header={header}
                    closable={closable}
                    dismissOnOutsideClick={dismissOnOutsideClick}
                    onAnimationEnd={onAnimationEnd}
                    {...props}
                />
            )}
        </DrawerProvider>
    );
};
